import React, { Suspense } from 'react';
import { useParams } from 'react-router-dom';

const RetinaComponentLazy = React.lazy(() => import('./_retina.component').then((module) => ({ default: module.Video })));

export function ScreenVideo() {
	const { ticket } = useParams();

	if (ticket == null) return null;

	return (
		<div
			style={{
				height: '100%',
				width: '100%',
				position: 'absolute',
				display: 'flex',
			}}
		>
			<Suspense fallback={null}>
				<RetinaComponentLazy ticket={ticket} />
			</Suspense>
		</div>
	);
}
